// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#eb5757","bgColor":"white","header":"g_g","row":"g_r","text":"g_t","rate":"g_v","tag":"g_w"};